import { StateToken } from './state-token.model'

/** this base-class is needed for state management.
 * (Generics cannot be easily (if at all) handled by ngrx entity.)
 */
export class NavStateContainerBase {
  /** this is the browser navigation event id, used for forward browser navigation. */
  navId: number
  /** initial url for this site */
  url: string
  // token: string;
  // urlToken: string; // duplicated data
  // compToken: string;
  baseState: any
  tokenObj: StateToken

  static generateFullToken(urlToken: string, compToken?: string): string {
    return `${urlToken}${!!compToken ? '_' : ''}${compToken}`
  }
}
/**
 * @export
 * Base class to manage site state for back-navigation from browser.
 *
 * (With this class and more specific child-classes site- and child-components will be enabled to restore the selections the user made before navigating away from that site.)
 *
 */
export class NavStateContainer<T> extends NavStateContainerBase {
  // private _compState: T;
  _compState: T

  get compState(): T {
    return this._compState
  }
  set compState(customState: T) {
    // console.log('setting compState to: ', customState);
    this._compState = customState
    this.baseState = customState
  }

  reviveCompState() {
    // console.log('reviving compState from baseState: ', this.baseState);
    this._compState = this.baseState as T
  }

  cloneAndReviveCompState(): NavStateContainer<T> {
    const result = { ...this } as NavStateContainer<T>
    result.reviveCompState()
    return result
  }
}
